import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api, { apiErrorMessage } from "@/lib/api";
import { ADMIN_TRAIN } from "@/constants/testIds";
import { ALL_ROLES, ROLE_LABELS } from "@/lib/permissions";

const EMPTY = { title: "", body: "", audience: "all", pinned: false };

export default function AdminAnnouncements() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const reload = async () => {
    try { const { data } = await api.get("/admin/training/announcements"); setItems(data); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); }, []);

  const submit = async () => {
    setBusy(true); setErr("");
    try { await api.post("/admin/training/announcements", form); setForm(EMPTY); await reload(); }
    catch (e) { setErr(apiErrorMessage(e)); }
    finally { setBusy(false); }
  };
  const del = async (id) => {
    if (!window.confirm("Delete this announcement?")) return;
    await api.delete(`/admin/training/announcements/${id}`); await reload();
  };

  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Training admin</div>
        <h1 className="headline-xl">Announcements</h1>
      </header>

      {err && <div className="text-rose-300 text-sm">{err}</div>}

      <div className="glass-panel p-5">
        <div className="eyebrow !text-lifted-text-dim mb-3">Broadcast</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <input className="input-lifted md:col-span-2" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <textarea className="input-lifted md:col-span-2 min-h-[100px]" placeholder="Body" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
          <select className="input-lifted" value={form.audience} onChange={(e) => setForm({ ...form, audience: e.target.value })}>
            <option value="all">All learners</option>
            <option value="affiliate">Track: affiliate</option>
            <option value="driver">Track: driver</option>
            <option value="partner">Track: partner</option>
            <option value="franchise">Track: franchise</option>
            <optgroup label="Roles">
              {ALL_ROLES.map((r) => <option key={r} value={r}>Role: {ROLE_LABELS[r]}</option>)}
            </optgroup>
          </select>
          <label className="flex items-center gap-2 text-sm text-lifted-dim">
            <input type="checkbox" checked={form.pinned} onChange={(e) => setForm({ ...form, pinned: e.target.checked })} /> Pinned
          </label>
        </div>
        <button data-testid={ADMIN_TRAIN.announcementCreate} onClick={submit} disabled={busy} className="btn-lifted mt-4 !text-[0.7rem]">
          <Plus className="h-3 w-3" /> {busy ? "Saving…" : "Publish"}
        </button>
      </div>

      <div data-testid={ADMIN_TRAIN.announcementsList} className="space-y-3">
        {items.map((a) => (
          <div key={a.id} className="glass-panel p-5 flex items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-2">
                {a.pinned && <span className="chip chip--green !text-[0.6rem]">Pinned</span>}
                <span className="chip">{a.audience}</span>
                <span className="text-xs text-lifted-mute">{a.created_at}</span>
              </div>
              <div className="font-anton text-xl uppercase mt-1">{a.title}</div>
              <p className="text-sm text-lifted-dim mt-1">{a.body}</p>
            </div>
            <button onClick={() => del(a.id)} className="btn-ghost !py-1.5 !px-3 !text-[0.65rem] hover:!text-rose-300"><Trash2 className="h-3 w-3" /></button>
          </div>
        ))}
        {items.length === 0 && <div className="text-lifted-mute text-sm">No announcements.</div>}
      </div>
    </div>
  );
}
